import { createContentSlice } from './contentSlice';
import { usersApi } from '../../api/users';

const { slice, actions } = createContentSlice({
  name: 'users',
  api: usersApi,
  keyField: 'id',
});

export const userReducer = slice.reducer;
export const userActions = actions;

export const selectUsers = (state) => state.users.items;
export const selectUsersStatus = (state) => state.users.status;